// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { createCustomerPayment, getCurrentOrder, getCurrentGroupOrder, verifyCustomerPayment, getSingleOrderById, } from "../../ApiService/Apis/order/order";

// import { getLocalStorageItem, getImageUrl } from "../../Utils/Index";
// import UseSocket from "../../Hooks/UseSocket";
// import OrderSkeleton from "./OrderSkeleton";
// import { Images } from "../../Helper/Index";
// import { triggerSnackbar } from "../../Services/NotificationService";
// import { useNavigate } from "react-router-dom";
// const STATUS_STEPS = [
//   "waiting for confirmation",
//   "waiting",
//   "preparing",
//   "prepared",
//   "served",
//   "completed",
// ];

// const normalizeStatus = (status) =>

//   (status || "")

//     .toString()

//     .toLowerCase()

//     .replace(/_/g, " ")

//     .replace(/-/g, " ")

//     .trim();

// const getStatusIndex = (status) => {

//   const idx = STATUS_STEPS.indexOf(normalizeStatus(status));

//   return idx === -1 ? 0 : idx;

// };

// const isRejected = (status) => normalizeStatus(status) === "rejected";

// const STATUS_LABELS = {

//   "waiting for confirmation": "Waiting for Confirmation",

//   waiting: "Waiting",

//   preparing: "Preparing",

//   prepared: "Prepared",

//   served: "Served",

//   completed: "Completed",

// };

// const STATUS_COLORS = {

//   "waiting for confirmation": {

//     text: "text-orange-400",

//     dot: "bg-orange-400",

//     bar: "from-orange-400 to-orange-300",

//     badgeBg: "bg-orange-500/10",

//     badgeBorder: "border-orange-500/40",

//   },

//   waiting: {

//     text: "text-yellow-400",

//     dot: "bg-yellow-400",

//     bar: "from-yellow-400 to-amber-300",

//     badgeBg: "bg-yellow-500/10",

//     badgeBorder: "border-yellow-500/40",

//   },

//   preparing: {

//     text: "text-blue-400",

//     dot: "bg-blue-400",

//     bar: "from-blue-400 to-cyan-300",

//     badgeBg: "bg-blue-500/10",

//     badgeBorder: "border-blue-500/40",

//   },

//   prepared: {

//     text: "text-purple-400",

//     dot: "bg-purple-400",

//     bar: "from-purple-400 to-fuchsia-300",

//     badgeBg: "bg-purple-500/10",

//     badgeBorder: "border-purple-500/40",

//   },

//   served: {

//     text: "text-teal-400",

//     dot: "bg-teal-400",

//     bar: "from-teal-400 to-emerald-300",

//     badgeBg: "bg-teal-500/10",

//     badgeBorder: "border-teal-500/40",

//   },

//   completed: {

//     text: "text-green-400",

//     dot: "bg-green-400",

//     bar: "from-green-400 to-emerald-300",

//     badgeBg: "bg-green-500/10",

//     badgeBorder: "border-green-500/40",

//   },

// };

// const CACHE_KEY = "cached_current_orders";

// const CACHE_SUMMARY_KEY = "cached_current_order_summary";

// const CurrentOrder = () => {

//   const navigate = useNavigate();

//   const [currentOrderList, setCurrentOrderList] = useState(() => {

//     try {

//       const cached = localStorage.getItem(CACHE_KEY);

//       return cached ? JSON.parse(cached) : [];

//     } catch {

//       return [];

//     }

//   });

//   const [OrderSummary, setOrderSummary] = useState(() => {

//     try {

//       const cached = localStorage.getItem(CACHE_SUMMARY_KEY);

//       return cached ? JSON.parse(cached) : { tax: 0, total: 0 };

//     } catch {

//       return { tax: 0, total: 0 };

//     }

//   });

//   const [loader, setLoader] = useState(currentOrderList.length === 0);

//   const [btnLoading, setBtnLoading] = useState(false);

//   const [highlightedOrderId, setHighlightedOrderId] = useState(null);

//   const [rejectedOrderId, setRejectedOrderId] = useState(null);

//   const [completedOrderId, setCompletedOrderId] = useState(null);

//   const customerId = Number(getLocalStorageItem("customerId") || null);

//   const sessionId = Number(getLocalStorageItem("sessionId") || null);

//   const highlightTimeoutRef = useRef(null);

//   const rejectedTimeoutRef = useRef(null);

//   const completedTimeoutRef = useRef(null);

//   // Refs for stable references

//   const currentOrderListRef = useRef(currentOrderList);

//   const sessionIdRef = useRef(sessionId);

//   const customerIdRef = useRef(customerId);

//   useEffect(() => {

//     currentOrderListRef.current = currentOrderList;

//   }, [currentOrderList]);

//   useEffect(() => {

//     sessionIdRef.current = sessionId;

//   }, [sessionId]);

//   useEffect(() => {

//     customerIdRef.current = customerId;

//   }, [customerId]);

//   // ============================================================

//   // FETCH FUNCTIONS

//   // ============================================================

//   const getCustomerCurrentOrder = useCallback(() => {

//     if (currentOrderListRef.current.length === 0) setLoader(true);

//     getCurrentOrder(`?customerId=${customerIdRef.current}`)

//       .then((res) => {

//         if (res.status) {

//           setCurrentOrderList(res.data);

//           const summary = {

//             tax: res.data?.reduce((a, b) => {

//               a = a + (b.totalItems * b.totalBasePrice * b.totalTax) / 100;

//               return a;

//             }, 0),

//             total: res.data?.reduce((a, b) => a + b.totalPriceAfterTax, 0),

//           };

//           setOrderSummary(summary);

//           try {

//             localStorage.setItem(CACHE_KEY, JSON.stringify(res.data));

//             localStorage.setItem(CACHE_SUMMARY_KEY, JSON.stringify(summary));

//           } catch (e) {

//             console.log("Cache write failed:", e);

//           }

//         }

//       })

//       .catch((err) => console.log(err))

//       .finally(() => setLoader(false));

//   }, []);

//   const getCustomerCurrentGroupOrder = useCallback(() => {

//     if (currentOrderListRef.current.length === 0) setLoader(true);

//     getCurrentGroupOrder(`/${sessionIdRef.current}`)

//       .then((res) => {

//         if (res.status) {

//           setCurrentOrderList(res.data);

//           const summary = {

//             tax: res.data?.reduce((a, b) => {

//               a = a + (b.totalItems * b.totalBasePrice * b.totalTax) / 100;

//               return a;

//             }, 0),

//             total: res.data?.reduce((a, b) => a + b.totalPriceAfterTax, 0),

//           };

//           setOrderSummary(summary);

//           try {

//             localStorage.setItem(CACHE_KEY, JSON.stringify(res.data));

//             localStorage.setItem(CACHE_SUMMARY_KEY, JSON.stringify(summary));

//           } catch (e) {

//             console.log("Cache write failed:", e);

//           }

//         }

//       })

//       .catch((err) => console.log(err))

//       .finally(() => setLoader(false));

//   }, []);

//   // Single stable entry point: always pulls fresh truth from the server

//   // rather than hand-patching local state. This is what keeps the UI in

//   // sync even if a socket event is missed by one listener but not another,

//   // if two updates arrive close together, or if status regresses

//   // (e.g. prepared -> waiting).

//   const refreshCurrentOrders = useCallback(() => {

//     if (sessionIdRef.current) {

//       getCustomerCurrentGroupOrder();

//     } else {

//       getCustomerCurrentOrder();

//     }

//   }, [getCustomerCurrentGroupOrder, getCustomerCurrentOrder]);

//   // Pass refreshCurrentOrders in as the socket hook's apiCall so that even

//   // if this component's own listener below is momentarily detached

//   // (e.g. during a reconnect), the hook-level listener still refetches.

//   const { socket } = UseSocket("customer", () => { }, refreshCurrentOrders);

//   // ============================================================

//   // ANIMATION FUNCTIONS

//   // ============================================================

//   const triggerHighlight = useCallback((orderId) => {

//     setHighlightedOrderId(orderId);

//     if (highlightTimeoutRef.current) clearTimeout(highlightTimeoutRef.current);

//     highlightTimeoutRef.current = setTimeout(() => {

//       setHighlightedOrderId(null);

//     }, 2200);

//   }, []);

//   const triggerRejectedShake = useCallback((orderId) => {

//     setRejectedOrderId(orderId);

//     if (rejectedTimeoutRef.current) clearTimeout(rejectedTimeoutRef.current);

//     rejectedTimeoutRef.current = setTimeout(() => {

//       setRejectedOrderId(null);

//     }, 900);

//   }, []);

//   const triggerCompletedCelebration = useCallback((orderId) => {

//     setCompletedOrderId(orderId);

//     if (completedTimeoutRef.current) clearTimeout(completedTimeoutRef.current);

//     completedTimeoutRef.current = setTimeout(() => {

//       setCompletedOrderId(null);

//     }, 2500);

//   }, []);

//   // ============================================================

//   // INITIAL FETCH

//   // ============================================================

//   useEffect(() => {

//     console.log("[CURRENT ORDER] customerId:", getLocalStorageItem("customerId"));

//     console.log("[CURRENT ORDER] sessionId:", getLocalStorageItem("sessionId"));

//     console.log("[CURRENT ORDER] pathname:", window.location.pathname);

//     refreshCurrentOrders();

//     // eslint-disable-next-line react-hooks/exhaustive-deps

//   }, []);

//   // ============================================================

//   // RAZORPAY SCRIPT

//   // ============================================================

//   useEffect(() => {

//     const script = document.createElement("script");

//     script.src = "https://checkout.razorpay.com/v1/checkout.js";

//     script.async = true;

//     document.body.appendChild(script);

//     return () => document.body.removeChild(script);

//   }, []);

//   // ============================================================

//   // SOCKET CONNECTION - JOIN CUSTOMER ROOM

//   // ============================================================

//   useEffect(() => {

//     if (!socket) return;

//     // The backend emits to customer-{customerId}

//     // So we need to join the customer room

//     if (customerIdRef.current) {

//       console.log("[CURRENT ORDER] Joining customer room:", customerIdRef.current);

//       socket.emit("join_customer_room", { customerId: customerIdRef.current });

//     }

//     // Also join group session if exists

//     if (sessionIdRef.current) {

//       console.log("[CURRENT ORDER] Joining group session:", sessionIdRef.current);

//       socket.emit("join_group_session", { sessionId: sessionIdRef.current });

//     }

//     // Join order rooms for each order

//     currentOrderListRef.current.forEach((order) => {

//       if (order?.id) {

//         console.log("[CURRENT ORDER] Joining order room:", order.id);

//         socket.emit("join_order_room", {

//           orderId: order.id,

//           orderType: order.sessionId ? "group" : "single",

//         });

//       }

//     });

//     // A fresh socket connection means we may have missed events while

//     // disconnected/reconnecting - resync immediately.

//     refreshCurrentOrders();

//     return () => {

//       if (socket) {

//         socket.emit("leave_customer_room", { customerId: customerIdRef.current });

//       }

//     };

//     // eslint-disable-next-line react-hooks/exhaustive-deps

//   }, [socket]);

//   // ============================================================

//   // SOCKET EVENT LISTENERS

//   // ============================================================

//   useEffect(() => {

//     if (!socket) {

//       console.log("[CURRENT ORDER] Socket not available");

//       return;

//     }

//     console.log("[CURRENT ORDER] Setting up socket event listeners...");

//     const playSound = () => {

//       try {

//         const audio = new Audio("/notification.mpeg");

//         audio.play().catch((err) => console.log("Audio play error:", err));

//       } catch (error) {

//         console.log("Notification audio error:", error);

//       }

//     };

//     // ============================================================

//     // ORDER STATUS UPDATE - Single Order

//     // ============================================================

//     const handleOrderStatusUpdate = (data) => {

//       console.log("[CURRENT ORDER] 📦 order_status_update received:", data);

//       const orderId = data?.orderId;

//       const status = data?.status;

//       if (!orderId || !status) {

//         console.warn("[CURRENT ORDER] Invalid order status update data:", data);

//         return;

//       }

//       playSound();

//       const normalizedStatus = normalizeStatus(status);

//       const statusLabel = STATUS_LABELS[normalizedStatus] || status;

//       triggerSnackbar(

//         `Order ${statusLabel}`,

//         normalizedStatus === "rejected" || normalizedStatus === "cancelled" ? "error" : "success"

//       );

//       // Trigger the right animation for this order id

//       if (normalizedStatus === "rejected" || normalizedStatus === "cancelled") {

//         triggerRejectedShake(Number(orderId));

//       } else if (normalizedStatus === "completed") {

//         triggerCompletedCelebration(Number(orderId));

//       } else {

//         triggerHighlight(Number(orderId));

//       }

//       // ALWAYS refetch from the server instead of hand-patching the local

//       // array. This is what fixes the "status stuck on a stale value"

//       // bug: manual splicing silently fails to update the UI if the

//       // order lookup misses, if this listener isn't attached at the

//       // exact moment the event arrives (e.g. during a socket reconnect),

//       // or if two status updates race each other. A refetch is always

//       // correct because it reflects exactly what the backend has.

//       refreshCurrentOrders();

//     };

//     // ============================================================

//     // GROUP ORDER STATUS UPDATE

//     // ============================================================

//     const handleGroupOrderStatusUpdate = (data) => {

//       console.log("[CURRENT ORDER] 📦 group_order_status_update received:", data);

//       const sessionIdFromEvent = data?.sessionId;

//       const status = data?.status;

//       if (!sessionIdFromEvent) {

//         console.warn("[CURRENT ORDER] Invalid group order status update:", data);

//         return;

//       }

//       playSound();

//       triggerSnackbar(`Group order ${status || "updated"}`, "info");

//       refreshCurrentOrders();

//     };

//     // ============================================================

//     // GROUP ORDER FINALIZED

//     // ============================================================

//     const handleGroupOrderFinalized = (data) => {

//       console.log("[CURRENT ORDER] 🎉 group_order_finalized received:", data);

//       playSound();

//       triggerSnackbar(`Group order finalized!`, "success");

//       refreshCurrentOrders();

//     };

//     // ============================================================

//     // GROUP ORDER PLACED

//     // ============================================================

//     const handleGroupOrderPlaced = (data) => {

//       console.log("[CURRENT ORDER] 📦 group_order_placed received:", data);

//       const orderNumber = data?.orderNumber;

//       playSound();

//       triggerSnackbar(`Group order placed! Order #${orderNumber || ""}`, "success");

//       refreshCurrentOrders();

//     };

//     // ============================================================

//     // GROUP ORDER ACTION

//     // ============================================================

//     const handleGroupOrderAction = (data) => {

//       console.log("[CURRENT ORDER] 📦 group_order_action received:", data);

//       const action = data?.action;

//       const actionMessages = {

//         add: "Item added to group order",

//         remove: "Item removed from group order",

//         update: "Item updated in group order",

//       };

//       triggerSnackbar(actionMessages[action] || "Group order updated", "info");

//       refreshCurrentOrders();

//     };

//     // ============================================================

//     // REFRESH GROUP ORDER

//     // ============================================================

//     const handleRefreshGroupOrder = (data) => {

//       console.log("[CURRENT ORDER] 🔄 refresh_group_order received:", data);

//       refreshCurrentOrders();

//     };

//     // ============================================================

//     // GROUP SESSION STATE

//     // ============================================================

//     const handleGroupSessionState = (data) => {

//       console.log("[CURRENT ORDER] 📊 group_session_state received:", data);

//     };

//     // ============================================================

//     // REGISTER EVENT LISTENERS

//     // ============================================================

//     socket.on("order_status_update", handleOrderStatusUpdate);

//     socket.on("group_order_status_update", handleGroupOrderStatusUpdate);

//     socket.on("group_order_finalized", handleGroupOrderFinalized);

//     socket.on("group_order_placed", handleGroupOrderPlaced);

//     socket.on("group_order_action", handleGroupOrderAction);

//     socket.on("refresh_group_order", handleRefreshGroupOrder);

//     socket.on("group_session_state", handleGroupSessionState);

//     console.log("[CURRENT ORDER] ✅ Socket event listeners registered");

//     return () => {

//       console.log("[CURRENT ORDER] Removing socket event listeners");

//       socket.off("order_status_update", handleOrderStatusUpdate);

//       socket.off("group_order_status_update", handleGroupOrderStatusUpdate);

//       socket.off("group_order_finalized", handleGroupOrderFinalized);

//       socket.off("group_order_placed", handleGroupOrderPlaced);

//       socket.off("group_order_action", handleGroupOrderAction);

//       socket.off("refresh_group_order", handleRefreshGroupOrder);

//       socket.off("group_session_state", handleGroupSessionState);

//       if (highlightTimeoutRef.current) clearTimeout(highlightTimeoutRef.current);

//       if (rejectedTimeoutRef.current) clearTimeout(rejectedTimeoutRef.current);

//       if (completedTimeoutRef.current) clearTimeout(completedTimeoutRef.current);

//     };

//     // eslint-disable-next-line react-hooks/exhaustive-deps

//   }, [socket, refreshCurrentOrders, triggerHighlight, triggerRejectedShake, triggerCompletedCelebration]);

//   // ============================================================

//   // HANDLE RAZORPAY PAYMENT

//   // ============================================================

//   const handleConfirmRZP = () => {

//     setBtnLoading(true);

//     createCustomerPayment({ amount: OrderSummary?.total, orderId: currentOrderList[0]?.id })

//       .then((response) => {

//         if (response.success) {

//           var options = {

//             amount: response.order.amount * 100,

//             currency: "INR",

//             name: "Restaurant",

//             description: "Test Transaction",

//             image: Images.tablefree,

//             order_id: response.order.id ?? "",

//             handler: (response) => {

//               setBtnLoading(true);

//               verifyCustomerPayment({

//                 razorpay_payment_id: response.razorpay_payment_id,

//                 razorpay_order_id: response.razorpay_order_id,

//               })

//                 .then((res) => {

//                   if (res.status) {

//                     refreshCurrentOrders();

//                     triggerSnackbar(res.message, "success");

//                   }

//                 })

//                 .catch((err) => console.log(err))

//                 .finally(() => setBtnLoading(false));

//             },

//             prefill: {

//               name: response.name,

//               email: response.email,

//               contact: response.contact,

//             },

//             theme: { color: "#3399cc" },

//           };

//           const rzp = new window.Razorpay(options);

//           rzp.open();

//         }

//       })

//       .catch((err) => console.log(err))

//       .finally(() => setBtnLoading(false));

//   };

//   // ============================================================

//   // RENDER

//   // ============================================================

//   return (
//     <>
//       <style>{`

//         @keyframes cardPulse {

//           0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6); }

//           70% { box-shadow: 0 0 0 12px rgba(34, 197, 94, 0); }

//           100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }

//         }

//         @keyframes cardFlash {

//           0% { background-color: rgba(34, 197, 94, 0.15); }

//           100% { background-color: transparent; }

//         }

//         @keyframes cardShake {

//           0%, 100% { transform: translateX(0); }

//           20% { transform: translateX(-6px); }

//           40% { transform: translateX(6px); }

//           60% { transform: translateX(-4px); }

//           80% { transform: translateX(4px); }

//         }

//         @keyframes cardFlashRed {

//           0% { background-color: rgba(239, 68, 68, 0.2); }

//           100% { background-color: transparent; }

//         }

//         @keyframes cardGlowGreen {

//           0% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7); }

//           50% { box-shadow: 0 0 24px 6px rgba(16, 185, 129, 0.5); }

//           100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }

//         }

//         @keyframes statusFadeIn {

//           0% { opacity: 0; transform: translateY(-6px); }

//           100% { opacity: 1; transform: translateY(0); }

//         }

//         @keyframes dotPop {

//           0% { transform: scale(0.4); opacity: 0; }

//           60% { transform: scale(1.3); opacity: 1; }

//           100% { transform: scale(1); opacity: 1; }

//         }

//         @keyframes dotGlowPulse {

//           0%, 100% { box-shadow: 0 0 0 0 currentColor; }

//           50% { box-shadow: 0 0 8px 2px currentColor; }

//         }

//         @keyframes rejectedIconPop {

//           0% { transform: scale(0) rotate(-45deg); opacity: 0; }

//           60% { transform: scale(1.2) rotate(0deg); opacity: 1; }

//           100% { transform: scale(1) rotate(0deg); opacity: 1; }

//         }

//         @keyframes checkPop {

//           0% { transform: scale(0) rotate(-20deg); opacity: 0; }

//           50% { transform: scale(1.3) rotate(5deg); opacity: 1; }

//           100% { transform: scale(1) rotate(0deg); opacity: 1; }

//         }

//         @keyframes confettiFall {

//           0% { transform: translateY(-10px) rotate(0deg); opacity: 1; }

//           100% { transform: translateY(60px) rotate(360deg); opacity: 0; }

//         }

//         @keyframes shimmer {

//           0% { background-position: -200% 0; }

//           100% { background-position: 200% 0; }

//         }

//         .order-card-highlight {

//           animation: cardPulse 1.4s ease-out, cardFlash 2s ease-out;

//         }

//         .order-card-rejected-shake {

//           animation: cardShake 0.6s ease-in-out, cardFlashRed 2s ease-out;

//         }

//         .order-card-completed-glow {

//           animation: cardGlowGreen 2.2s ease-out;

//         }

//         .status-text-animate {

//           animation: statusFadeIn 0.35s ease-out;

//         }

//         .status-dot-animate {

//           animation: dotPop 0.4s ease-out;

//         }

//         .status-dot-active {

//           animation: dotGlowPulse 1.8s ease-in-out infinite;

//         }

//         .rejected-icon-animate {

//           animation: rejectedIconPop 0.45s ease-out;

//         }

//         .check-icon-animate {

//           animation: checkPop 0.5s ease-out;

//         }

//         .status-progress-fill {

//           transition: width 0.7s cubic-bezier(0.34, 1.56, 0.64, 1);

//         }

//         .confetti-piece {

//           position: absolute;

//           width: 6px;

//           height: 6px;

//           border-radius: 1px;

//           animation: confettiFall 1.4s ease-in forwards;

//         }

//         .shimmer-bar {

//           background: linear-gradient(90deg, transparent, rgba(255,255,255,0.35), transparent);

//           background-size: 200% 100%;

//           animation: shimmer 1.6s linear infinite;

//         }

//       `}</style>

//       {loader ? (
//         <OrderSkeleton />

//       ) : (
//         <>

//           {currentOrderList?.length > 0 ? (

//             currentOrderList?.map((i, index) => {

//               const rejected = isRejected(i.orderStatus);

//               const statusKey = normalizeStatus(i.orderStatus);

//               const statusIndex = getStatusIndex(i.orderStatus);

//               const progressPercent = (statusIndex / (STATUS_STEPS.length - 1)) * 100;

//               const isHighlighted = Number(highlightedOrderId) === Number(i.id);

//               const isShaking = Number(rejectedOrderId) === Number(i.id);

//               const isCelebrating = Number(completedOrderId) === Number(i.id);

//               const colors = STATUS_COLORS[statusKey] || STATUS_COLORS.waiting;

//               const isCompleted = statusKey === "completed";

//               return (
//                 <div key={i.id || index} className="relative">

//                   {isCelebrating && (
//                     <div className="absolute top-2 right-4 pointer-events-none z-10">

//                       {["#22c55e", "#eab308", "#3b82f6", "#ec4899", "#a855f7"].map((c, ci) => (
//                         <span

//                           key={ci}

//                           className="confetti-piece"

//                           style={{

//                             backgroundColor: c,

//                             left: `${ci * 10}px`,

//                             animationDelay: `${ci * 0.08}s`,

//                           }}
//                         ></span>

//                       ))}
//                     </div>

//                   )}

//                   {(i?.customerItems?.length > 0 || i?.orderFoodMappings?.length > 0) ? (
//                     <div

//                       className={`bg-dynmaicBg3 mt-2 p-2 rounded-sm transition-all duration-300 ${isHighlighted ? "order-card-highlight" : ""

//                         } ${isShaking ? "order-card-rejected-shake" : ""} ${isCelebrating ? "order-card-completed-glow" : ""

//                         } ${rejected ? "border border-red-500/50" : ""} ${isCompleted ? "border border-green-500/40" : ""

//                         }`}
//                     >
//                       <div className="flex justify-between items-center">

//                         {!rejected && (
//                           <span

//                             key={statusKey}

//                             className={`status-text-animate text-[10px] font-semibold px-2 py-0.5 rounded-full border ${colors.badgeBg} ${colors.badgeBorder} ${colors.text}`}
//                           >

//                             {STATUS_LABELS[statusKey] || i?.orderStatus}
//                           </span>

//                         )}
//                         <p className="flex justify-end text-dynmaicText font-inter text-xs items-center ml-auto">

//                           {new Date(i?.orderDateTime).toDateString()}
//                         </p>
//                       </div>

//                       {i.orderFoodMappings?.map((i2, idx) => (
//                         <div key={i2.id || idx}>
//                           <div className="flex justify-between items-center mb-1 mt-2">
//                             <div className="flex justify-center gap-3 flex-wrap items-center">
//                               <img

//                                 onError={(e) => {

//                                   e.target.src = "https://suzlon.vtlabs.dev/web/images/2.png";

//                                   e.target.alt = "foodImage";

//                                 }}

//                                 src={

//                                   i2.foodDetails?.foodImage?.length > 0

//                                     ? getImageUrl(i2.foodDetails?.foodImage[0])

//                                     : "https://suzlon.vtlabs.dev/web/images/2.png"

//                                 }

//                                 className="w-[40px] rounded-sm"

//                                 alt="foodImage"

//                               />
//                               <p className="text-dynmaicText text-xs mt-1">

//                                 {i2.quantity} X{" "}
//                                 <span>

//                                   {i2?.foodDetails?.name ?? "--"}
//                                   <br />({i2?.foodVariantName})
//                                 </span>
//                               </p>
//                             </div>
//                             <p className="text-dynmaicText font-inter text-xs">

//                               ₹ {i2?.totalItemPriceAfterTax}
//                             </p>
//                           </div>

//                           {idx !== i.orderFoodMappings?.length - 1 && <hr />}
//                         </div>

//                       ))}

//                       {rejected ? (
//                         <div className="mt-3 flex items-center gap-2 bg-red-500/10 border border-red-500/40 rounded-md px-3 py-2">
//                           <span className="rejected-icon-animate text-red-500 text-lg leading-none">✕</span>
//                           <p className="text-red-400 font-inter text-xs font-semibold">Order Rejected</p>
//                         </div>

//                       ) : (
//                         <div className="mt-3">
//                           <div className="relative h-2 bg-gray-700 rounded-full overflow-hidden">
//                             <div

//                               className={`status-progress-fill absolute top-0 left-0 h-full rounded-full bg-gradient-to-r ${colors.bar} ${!isCompleted ? "shimmer-bar" : ""

//                                 }`}

//                               style={{ width: `${progressPercent}%` }}
//                             ></div>
//                           </div>
//                           <div className="flex justify-between mt-1.5">

//                             {STATUS_STEPS.map((step, stepIdx) => {

//                               const stepColors = STATUS_COLORS[step];

//                               const isActive = stepIdx === statusIndex;

//                               const isDone = stepIdx < statusIndex;

//                               const isReached = stepIdx <= statusIndex;

//                               return (
//                                 <div

//                                   key={step}

//                                   className="flex flex-col items-center"

//                                   style={{ width: `${100 / STATUS_STEPS.length}%` }}
//                                 >
//                                   <div

//                                     key={`${step}-${statusKey}`}

//                                     className={`w-2.5 h-2.5 rounded-full ${isReached

//                                       ? `${stepColors.dot} status-dot-animate`

//                                       : "bg-gray-600"

//                                       } ${isActive ? `status-dot-active ${stepColors.text}` : ""}`}
//                                   ></div>
//                                   <p

//                                     className={`text-[9px] mt-1 text-center leading-tight font-inter ${isDone

//                                       ? "text-gray-400"

//                                       : isActive

//                                         ? `${stepColors.text} font-semibold`

//                                         : "text-gray-600"

//                                       }`}
//                                   >

//                                     {STATUS_LABELS[step]}
//                                   </p>
//                                 </div>

//                               );

//                             })}
//                           </div>
//                         </div>

//                       )}

//                       <div className="flex justify-between items-center text-xs text-dynmaicText font-inter mt-3">
//                         <div className="flex items-center gap-1">

//                           {isCompleted && (
//                             <span className="check-icon-animate text-green-400 text-sm">✓</span>

//                           )}
//                           <p

//                             key={`label-${statusKey}`}

//                             className={`status-text-animate font-semibold ${rejected ? "text-red-500" : colors.text

//                               }`}
//                           >

//                             {rejected ? "Rejected" : STATUS_LABELS[statusKey] || i?.orderStatus}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="flex justify-between items-center text-dynmaicText font-inter mt-2">
//                         <p className="text-brand">Total Price</p>
//                         <p className="font-semibold">₹ {i?.summary?.totalPriceAfterTax}</p>
//                       </div>
//                     </div>

//                   ) : (
//                     <div className="flex justify-center items-center h-full mt-16 text-dynmaicText">
//                       <p className="font-bold text-2xl">No Order Yet!</p>
//                     </div>

//                   )}
//                 </div>

//               );

//             })

//           ) : OrderSummary?.total < 1 ? (
//             <div className="flex flex-col justify-center items-center bg-dynmaicBg3 p-6 mt-4 rounded-md">
//               <img

//                 src="https://cdn-icons-png.flaticon.com/512/709/709496.png"

//                 alt="waiting"

//                 className="w-12 h-12 mb-3 opacity-70"

//               />
//               <p className="text-yellow-400 font-semibold text-lg">Waiting for Orders...</p>
//               <p className="text-gray-400 text-sm mt-1 text-center">

//                 Your current order is in <span className="text-yellow-400">waiting status</span>.
//               </p>
//               <div

//                 onClick={() => navigate(-1)}

//                 className="font-inter bg-dynmaicBg2 text-center cursor-pointer mt-2 text-dynmaicText p-2"
//               >
//                 <p>Thanks</p>
//               </div>
//             </div>

//           ) : (
//             <div className="flex justify-center items-center h-full mt-16 text-dynmaicText">
//               <p className="font-bold text-2xl">No Order Yet!</p>
//             </div>

//           )}
//         </>

//       )}

//       {OrderSummary?.total > 0 && (
//         <>
//           <div className="mt-4 text-dynmaicText font-inter">
//             <p>Order Summary</p>
//             <div className="w-1/2 h-[2px] bg-green-400 mt-2"></div>
//             <div className="mt-2">
//               <div className="flex justify-between items-center">
//                 <p>Tax</p>
//                 <p>₹ {OrderSummary.tax}</p>
//               </div>
//               <div className="flex justify-between items-center">
//                 <p>Total Summary</p>
//                 <p>₹ {OrderSummary.total}</p>
//               </div>
//             </div>
//           </div>
//           <div

//             onClick={() => navigate(-1)}

//             className="font-inter bg-dynmaicBg2 text-center cursor-pointer mt-2 text-dynmaicText p-2"
//           >
//             <p>Thanks</p>
//           </div>
//         </>

//       )}
//     </>

//   );

// };

// export default CurrentOrder;


import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  createCustomerPayment,
  getCurrentOrder,
  getCurrentGroupOrder,
  verifyCustomerPayment,
} from "../../ApiService/Apis/order/order";
import { getLocalStorageItem, getImageUrl } from "../../Utils/Index";
import UseSocket from "../../Hooks/UseSocket";
import OrderSkeleton from "./OrderSkeleton";
import { Images } from "../../Helper/Index";
import { triggerSnackbar } from "../../Services/NotificationService";
import { useNavigate } from "react-router-dom";

const STATUS_STEPS = [
  "waiting for confirmation",
  "waiting",
  "preparing",
  "prepared",
  "served",
  "completed",
];

const normalizeStatus = (status) =>
  (status || "").toString().toLowerCase().replace(/_/g, " ").replace(/-/g, " ").trim();

const getStatusIndex = (status) => {
  const idx = STATUS_STEPS.indexOf(normalizeStatus(status));
  return idx === -1 ? 0 : idx;
};

const isRejected = (status) => normalizeStatus(status) === "rejected";

const STATUS_LABELS = {
  "waiting for confirmation": "Waiting for Confirmation",
  waiting: "Waiting",
  preparing: "Preparing",
  prepared: "Prepared",
  served: "Served",
  completed: "Completed",
};

const STATUS_COLORS = {
  "waiting for confirmation": {
    text: "text-orange-400",
    dot: "bg-orange-400",
    bar: "from-orange-400 to-orange-300",
    badgeBg: "bg-orange-500/10",
    badgeBorder: "border-orange-500/40",
  },
  waiting: {
    text: "text-yellow-400",
    dot: "bg-yellow-400",
    bar: "from-yellow-400 to-amber-300",
    badgeBg: "bg-yellow-500/10",
    badgeBorder: "border-yellow-500/40",
  },
  preparing: {
    text: "text-blue-400",
    dot: "bg-blue-400",
    bar: "from-blue-400 to-cyan-300",
    badgeBg: "bg-blue-500/10",
    badgeBorder: "border-blue-500/40",
  },
  prepared: {
    text: "text-purple-400",
    dot: "bg-purple-400",
    bar: "from-purple-400 to-fuchsia-300",
    badgeBg: "bg-purple-500/10",
    badgeBorder: "border-purple-500/40",
  },
  served: {
    text: "text-teal-400",
    dot: "bg-teal-400",
    bar: "from-teal-400 to-emerald-300",
    badgeBg: "bg-teal-500/10",
    badgeBorder: "border-teal-500/40",
  },
  completed: {
    text: "text-green-400",
    dot: "bg-green-400",
    bar: "from-green-400 to-emerald-300",
    badgeBg: "bg-green-500/10",
    badgeBorder: "border-green-500/40",
  },
};

const CACHE_KEY = "cached_current_orders";
const CACHE_SUMMARY_KEY = "cached_current_order_summary";

const CurrentOrder = () => {
  const navigate = useNavigate();

  const [currentOrderList, setCurrentOrderList] = useState(() => {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      return cached ? JSON.parse(cached) : [];
    } catch {
      return [];
    }
  });

  const [OrderSummary, setOrderSummary] = useState(() => {
    try {
      const cached = localStorage.getItem(CACHE_SUMMARY_KEY);
      return cached ? JSON.parse(cached) : { tax: 0, total: 0 };
    } catch {
      return { tax: 0, total: 0 };
    }
  });

  const [loader, setLoader] = useState(currentOrderList.length === 0);
  const [btnLoading, setBtnLoading] = useState(false);
  const [highlightedOrderId, setHighlightedOrderId] = useState(null);
  const [rejectedOrderId, setRejectedOrderId] = useState(null);
  const [completedOrderId, setCompletedOrderId] = useState(null);

  const customerId = Number(getLocalStorageItem("customerId") || null);
  const sessionId = Number(getLocalStorageItem("sessionId") || null);

  const highlightTimeoutRef = useRef(null);
  const rejectedTimeoutRef = useRef(null);
  const completedTimeoutRef = useRef(null);

  // Refs for stable references
  const currentOrderListRef = useRef(currentOrderList);
  const sessionIdRef = useRef(sessionId);
  const customerIdRef = useRef(customerId);

  useEffect(() => {
    currentOrderListRef.current = currentOrderList;
  }, [currentOrderList]);

  useEffect(() => {
    sessionIdRef.current = sessionId;
  }, [sessionId]);

  useEffect(() => {
    customerIdRef.current = customerId;
  }, [customerId]);

  // ============================================================
  // FETCH FUNCTIONS
  // ============================================================

  const getCustomerCurrentOrder = useCallback(() => {
    if (currentOrderListRef.current.length === 0) setLoader(true);

    getCurrentOrder(`?customerId=${customerIdRef.current}`)
      .then((res) => {
        if (res.status) {
          setCurrentOrderList(res.data);
          const summary = {
            tax: res.data?.reduce((a, b) => {
              a = a + (b.totalItems * b.totalBasePrice * b.totalTax) / 100;
              return a;
            }, 0),
            total: res.data?.reduce((a, b) => a + b.totalPriceAfterTax, 0),
          };
          setOrderSummary(summary);
          try {
            localStorage.setItem(CACHE_KEY, JSON.stringify(res.data));
            localStorage.setItem(CACHE_SUMMARY_KEY, JSON.stringify(summary));
          } catch (e) {
            console.log("Cache write failed:", e);
          }
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoader(false));
  }, []);

  const getCustomerCurrentGroupOrder = useCallback(() => {
    if (currentOrderListRef.current.length === 0) setLoader(true);
    getCurrentGroupOrder(`/${sessionIdRef.current}`)
      .then((res) => {
        if (res.status) {
          setCurrentOrderList(res.data);
          const summary = {
            tax: res.data?.reduce((a, b) => {
              a = a + (b.totalItems * b.totalBasePrice * b.totalTax) / 100;
              return a;
            }, 0),
            total: res.data?.reduce((a, b) => a + b.totalPriceAfterTax, 0),
          };
          setOrderSummary(summary);
          try {
            localStorage.setItem(CACHE_KEY, JSON.stringify(res.data));
            localStorage.setItem(CACHE_SUMMARY_KEY, JSON.stringify(summary));
          } catch (e) {
            console.log("Cache write failed:", e);
          }
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoader(false));
  }, []);

  const refreshCurrentOrders = useCallback(() => {
    if (sessionIdRef.current) {
      getCustomerCurrentOrder();
    } else {
      getCustomerCurrentOrder();
    }
  }, [getCustomerCurrentGroupOrder, getCustomerCurrentOrder]);

  const { socket } = UseSocket("customer", () => {}, refreshCurrentOrders);

  // ============================================================
  // ANIMATION FUNCTIONS
  // ============================================================

  const triggerHighlight = useCallback((orderId) => {
    setHighlightedOrderId(orderId);
    if (highlightTimeoutRef.current) clearTimeout(highlightTimeoutRef.current);
    highlightTimeoutRef.current = setTimeout(() => setHighlightedOrderId(null), 2200);
  }, []);

  const triggerRejectedShake = useCallback((orderId) => {
    setRejectedOrderId(orderId);
    if (rejectedTimeoutRef.current) clearTimeout(rejectedTimeoutRef.current);
    rejectedTimeoutRef.current = setTimeout(() => setRejectedOrderId(null), 900);
  }, []);

  const triggerCompletedCelebration = useCallback((orderId) => {
    setCompletedOrderId(orderId);
    if (completedTimeoutRef.current) clearTimeout(completedTimeoutRef.current);
    completedTimeoutRef.current = setTimeout(() => setCompletedOrderId(null), 2500);
  }, []);

  // ============================================================
  // INITIAL FETCH
  // ============================================================

  useEffect(() => {
    console.log("[CURRENT ORDER] customerId:", getLocalStorageItem("customerId"));
    console.log("[CURRENT ORDER] sessionId:", getLocalStorageItem("sessionId"));
    refreshCurrentOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ============================================================
  // RAZORPAY SCRIPT
  // ============================================================

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);

  // ============================================================
  // SOCKET CONNECTION - JOIN ALL RELEVANT ROOMS
  // ============================================================
  // KEY FIX: Join BOTH customer room AND group session room
  // Because backend emits to customer-{id} for order updates
  // AND to group-session-{id} for group updates
  // ============================================================

  useEffect(() => {
    if (!socket) return;

    console.log("==============================================");
    console.log("[CURRENT ORDER] SOCKET CONNECTED - JOINING ROOMS");
    console.log("[CURRENT ORDER] customerId:", customerIdRef.current);
    console.log("[CURRENT ORDER] sessionId:", sessionIdRef.current);
    console.log("==============================================");

    // ✅ Join customer room - backend emits order_status_update here
    if (customerIdRef.current) {
      console.log("[CURRENT ORDER] Joining customer room:", customerIdRef.current);
      socket.emit("join_customer_room", { customerId: customerIdRef.current });
    }

    // ✅ Join group session room - backend emits group_order_status_update here
    if (sessionIdRef.current) {
      console.log("[CURRENT ORDER] Joining group session:", sessionIdRef.current);
      socket.emit("join_group_session", { sessionId: sessionIdRef.current });
    }

    // ✅ Join order rooms for each order (helps with single order flow)
    currentOrderListRef.current.forEach((order) => {
      if (order?.id) {
        console.log("[CURRENT ORDER] Joining order room:", order.id);
        socket.emit("join_order_room", {
          orderId: order.id,
          orderType: order.sessionId ? "group" : "single",
        });
      }
    });

    // Re-sync immediately on socket connect
    refreshCurrentOrders();

    return () => {
      if (socket) {
        socket.emit("leave_customer_room", { customerId: customerIdRef.current });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket]);

  // ============================================================
  // ALSO JOIN ROOMS WHEN ORDER LIST UPDATES (after API fetch)
  // ============================================================

  useEffect(() => {
    if (!socket?.connected) return;
    if (currentOrderList.length === 0) return;

    console.log("[CURRENT ORDER] Order list updated - re-joining rooms...");

    // Re-join customer room
    if (customerIdRef.current) {
      socket.emit("join_customer_room", { customerId: customerIdRef.current });
    }

    // Re-join group session
    if (sessionIdRef.current) {
      socket.emit("join_group_session", { sessionId: sessionIdRef.current });
    }

    // Re-join all order rooms
    currentOrderList.forEach((order) => {
      if (order?.id) {
        socket.emit("join_order_room", {
          orderId: order.id,
          orderType: order.sessionId ? "group" : "single",
        });
      }
      if (order?.sessionId) {
        socket.emit("join_group_session", { sessionId: order.sessionId });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, currentOrderList]);

  // ============================================================
  // SOCKET EVENT LISTENERS
  // ============================================================

  useEffect(() => {
    if (!socket) {
      console.log("[CURRENT ORDER] Socket not available");
      return;
    }

    console.log("[CURRENT ORDER] Setting up socket event listeners...");

    const playSound = () => {
      try {
        const audio = new Audio("/notification.mpeg");
        audio.play().catch((err) => console.log("Audio play error:", err));
      } catch (error) {
        console.log("Notification audio error:", error);
      }
    };

    // ============================================================
    // ORDER STATUS UPDATE - Handles BOTH single and group orders
    // ============================================================
    const handleOrderStatusUpdate = (data) => {
      console.log("[CURRENT ORDER] 📦 order_status_update received:", data);

      const orderId = data?.orderId;
      const status = data?.status;
      const incomingSessionId = data?.sessionId;

      if (!status) {
        console.warn("[CURRENT ORDER] No status in payload:", data);
        return;
      }

      // ✅ Handle both single order AND group order updates
      // Group orders come through with orderId but also have sessionId context
      if (!orderId && !incomingSessionId) {
        console.warn("[CURRENT ORDER] Neither orderId nor sessionId in payload:", data);
        return;
      }

      playSound();

      const normalizedStatus = normalizeStatus(status);
      const statusLabel = STATUS_LABELS[normalizedStatus] || status;

      triggerSnackbar(
        `Order ${statusLabel}`,
        normalizedStatus === "rejected" || normalizedStatus === "cancelled" ? "error" : "success"
      );

      // Trigger animation
      const targetId = Number(orderId) || Number(incomingSessionId);
      if (normalizedStatus === "rejected" || normalizedStatus === "cancelled") {
        triggerRejectedShake(targetId);
      } else if (normalizedStatus === "completed") {
        triggerCompletedCelebration(targetId);
      } else {
        triggerHighlight(targetId);
      }

      // ✅ ALWAYS refetch - this is the key fix
      refreshCurrentOrders();
    };

    // ============================================================
    // GROUP ORDER STATUS UPDATE
    // ============================================================
    const handleGroupOrderStatusUpdate = (data) => {
      console.log("[CURRENT ORDER] 📦 group_order_status_update received:", data);

      const incomingSessionId = data?.sessionId;
      const status = data?.status;

      if (!incomingSessionId) {
        console.warn("[CURRENT ORDER] Invalid group order status update:", data);
        return;
      }

      playSound();
      triggerSnackbar(`Group order ${status || "updated"}`, "info");
      refreshCurrentOrders();
    };

    // ============================================================
    // GROUP ORDER FINALIZED
    // ============================================================
    const handleGroupOrderFinalized = (data) => {
      console.log("[CURRENT ORDER] 🎉 group_order_finalized received:", data);
      playSound();
      triggerSnackbar(`Group order finalized!`, "success");
      refreshCurrentOrders();
    };

    // ============================================================
    // GROUP ORDER PLACED
    // ============================================================
    const handleGroupOrderPlaced = (data) => {
      console.log("[CURRENT ORDER] 📦 group_order_placed received:", data);
      const orderNumber = data?.orderNumber;
      playSound();
      triggerSnackbar(`Group order placed! Order #${orderNumber || ""}`, "success");
      refreshCurrentOrders();
    };

    // ============================================================
    // GROUP ORDER ACTION
    // ============================================================
    const handleGroupOrderAction = (data) => {
      console.log("[CURRENT ORDER] 📦 group_order_action received:", data);
      const action = data?.action;
      const actionMessages = {
        add: "Item added to group order",
        remove: "Item removed from group order",
        update: "Item updated in group order",
      };
      triggerSnackbar(actionMessages[action] || "Group order updated", "info");
      refreshCurrentOrders();
    };

    // ============================================================
    // REFRESH GROUP ORDER
    // ============================================================
    const handleRefreshGroupOrder = (data) => {
      console.log("[CURRENT ORDER] 🔄 refresh_group_order received:", data);
      refreshCurrentOrders();
    };

    // ============================================================
    // GROUP SESSION STATE
    // ============================================================
    const handleGroupSessionState = (data) => {
      console.log("[CURRENT ORDER] 📊 group_session_state received:", data);
    };

    // ============================================================
    // REGISTER EVENT LISTENERS
    // ============================================================
    socket.on("order_status_update", handleOrderStatusUpdate);
    socket.on("group_order_status_update", handleGroupOrderStatusUpdate);
    socket.on("group_order_finalized", handleGroupOrderFinalized);
    socket.on("group_order_placed", handleGroupOrderPlaced);
    socket.on("group_order_action", handleGroupOrderAction);
    socket.on("refresh_group_order", handleRefreshGroupOrder);
    socket.on("group_session_state", handleGroupSessionState);

    console.log("[CURRENT ORDER] ✅ Socket event listeners registered");

    return () => {
      console.log("[CURRENT ORDER] Removing socket event listeners");
      socket.off("order_status_update", handleOrderStatusUpdate);
      socket.off("group_order_status_update", handleGroupOrderStatusUpdate);
      socket.off("group_order_finalized", handleGroupOrderFinalized);
      socket.off("group_order_placed", handleGroupOrderPlaced);
      socket.off("group_order_action", handleGroupOrderAction);
      socket.off("refresh_group_order", handleRefreshGroupOrder);
      socket.off("group_session_state", handleGroupSessionState);

      if (highlightTimeoutRef.current) clearTimeout(highlightTimeoutRef.current);
      if (rejectedTimeoutRef.current) clearTimeout(rejectedTimeoutRef.current);
      if (completedTimeoutRef.current) clearTimeout(completedTimeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, refreshCurrentOrders, triggerHighlight, triggerRejectedShake, triggerCompletedCelebration]);

  // ============================================================
  // HANDLE RAZORPAY PAYMENT
  // ============================================================

  const handleConfirmRZP = () => {
    setBtnLoading(true);
    createCustomerPayment({ amount: OrderSummary?.total, orderId: currentOrderList[0]?.id })
      .then((response) => {
        if (response.success) {
          var options = {
            amount: response.order.amount * 100,
            currency: "INR",
            name: "Restaurant",
            description: "Test Transaction",
            image: Images.tablefree,
            order_id: response.order.id ?? "",
            handler: (response) => {
              setBtnLoading(true);
              verifyCustomerPayment({
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
              })
                .then((res) => {
                  if (res.status) {
                    refreshCurrentOrders();
                    triggerSnackbar(res.message, "success");
                  }
                })
                .catch((err) => console.log(err))
                .finally(() => setBtnLoading(false));
            },
            prefill: {
              name: response.name,
              email: response.email,
              contact: response.contact,
            },
            theme: { color: "#3399cc" },
          };
          const rzp = new window.Razorpay(options);
          rzp.open();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      <style>{`
        @keyframes cardPulse {
          0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6); }
          70% { box-shadow: 0 0 0 12px rgba(34, 197, 94, 0); }
          100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
        }
        @keyframes cardFlash {
          0% { background-color: rgba(34, 197, 94, 0.15); }
          100% { background-color: transparent; }
        }
        @keyframes cardShake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-6px); }
          40% { transform: translateX(6px); }
          60% { transform: translateX(-4px); }
          80% { transform: translateX(4px); }
        }
        @keyframes cardFlashRed {
          0% { background-color: rgba(239, 68, 68, 0.2); }
          100% { background-color: transparent; }
        }
        @keyframes cardGlowGreen {
          0% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7); }
          50% { box-shadow: 0 0 24px 6px rgba(16, 185, 129, 0.5); }
          100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
        }
        @keyframes statusFadeIn {
          0% { opacity: 0; transform: translateY(-6px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes dotPop {
          0% { transform: scale(0.4); opacity: 0; }
          60% { transform: scale(1.3); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes dotGlowPulse {
          0%, 100% { box-shadow: 0 0 0 0 currentColor; }
          50% { box-shadow: 0 0 8px 2px currentColor; }
        }
        @keyframes rejectedIconPop {
          0% { transform: scale(0) rotate(-45deg); opacity: 0; }
          60% { transform: scale(1.2) rotate(0deg); opacity: 1; }
          100% { transform: scale(1) rotate(0deg); opacity: 1; }
        }
        @keyframes checkPop {
          0% { transform: scale(0) rotate(-20deg); opacity: 0; }
          50% { transform: scale(1.3) rotate(5deg); opacity: 1; }
          100% { transform: scale(1) rotate(0deg); opacity: 1; }
        }
        @keyframes confettiFall {
          0% { transform: translateY(-10px) rotate(0deg); opacity: 1; }
          100% { transform: translateY(60px) rotate(360deg); opacity: 0; }
        }
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        .order-card-highlight {
          animation: cardPulse 1.4s ease-out, cardFlash 2s ease-out;
        }
        .order-card-rejected-shake {
          animation: cardShake 0.6s ease-in-out, cardFlashRed 2s ease-out;
        }
        .order-card-completed-glow {
          animation: cardGlowGreen 2.2s ease-out;
        }
        .status-text-animate {
          animation: statusFadeIn 0.35s ease-out;
        }
        .status-dot-animate {
          animation: dotPop 0.4s ease-out;
        }
        .status-dot-active {
          animation: dotGlowPulse 1.8s ease-in-out infinite;
        }
        .rejected-icon-animate {
          animation: rejectedIconPop 0.45s ease-out;
        }
        .check-icon-animate {
          animation: checkPop 0.5s ease-out;
        }
        .status-progress-fill {
          transition: width 0.7s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        .confetti-piece {
          position: absolute;
          width: 6px;
          height: 6px;
          border-radius: 1px;
          animation: confettiFall 1.4s ease-in forwards;
        }
        .shimmer-bar {
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.35), transparent);
          background-size: 200% 100%;
          animation: shimmer 1.6s linear infinite;
        }
      `}</style>

      {loader ? (
        <OrderSkeleton />
      ) : (
        <>
          {currentOrderList?.length > 0 ? (
            currentOrderList?.map((i, index) => {
              const rejected = isRejected(i.orderStatus);
              const statusKey = normalizeStatus(i.orderStatus);
              const statusIndex = getStatusIndex(i.orderStatus);
              const progressPercent = (statusIndex / (STATUS_STEPS.length - 1)) * 100;
              const isHighlighted = Number(highlightedOrderId) === Number(i.id);
              const isShaking = Number(rejectedOrderId) === Number(i.id);
              const isCelebrating = Number(completedOrderId) === Number(i.id);
              const colors = STATUS_COLORS[statusKey] || STATUS_COLORS.waiting;
              const isCompleted = statusKey === "completed";

              return (
                <div key={i.id || index} className="relative">
                  {isCelebrating && (
                    <div className="absolute top-2 right-4 pointer-events-none z-10">
                      {["#22c55e", "#eab308", "#3b82f6", "#ec4899", "#a855f7"].map((c, ci) => (
                        <span
                          key={ci}
                          className="confetti-piece"
                          style={{
                            backgroundColor: c,
                            left: `${ci * 10}px`,
                            animationDelay: `${ci * 0.08}s`,
                          }}
                        ></span>
                      ))}
                    </div>
                  )}

                  {(i?.customerItems?.length > 0 || i?.orderFoodMappings?.length > 0) ? (
                    <div
                      className={`bg-dynmaicBg3 mt-2 p-2 rounded-sm transition-all duration-300 ${
                        isHighlighted ? "order-card-highlight" : ""
                      } ${isShaking ? "order-card-rejected-shake" : ""} ${
                        isCelebrating ? "order-card-completed-glow" : ""
                      } ${rejected ? "border border-red-500/50" : ""} ${
                        isCompleted ? "border border-green-500/40" : ""
                      }`}
                    >
                      <div className="flex justify-between items-center">
                        {!rejected && (
                          <span
                            key={statusKey}
                            className={`status-text-animate text-[10px] font-semibold px-2 py-0.5 rounded-full border ${colors.badgeBg} ${colors.badgeBorder} ${colors.text}`}
                          >
                            {STATUS_LABELS[statusKey] || i?.orderStatus}
                          </span>
                        )}
                        <p className="flex justify-end text-dynmaicText font-inter text-xs items-center ml-auto">
                          {new Date(i?.orderDateTime).toDateString()}
                        </p>
                      </div>

                      {i.orderFoodMappings?.map((i2, idx) => (
                        <div key={i2.id || idx}>
                          <div className="flex justify-between items-center mb-1 mt-2">
                            <div className="flex justify-center gap-3 flex-wrap items-center">
                              <img
                                onError={(e) => {
                                  e.target.src = "https://suzlon.vtlabs.dev/web/images/2.png";
                                  e.target.alt = "foodImage";
                                }}
                                src={
                                  i2.foodDetails?.foodImage?.length > 0
                                    ? getImageUrl(i2.foodDetails?.foodImage[0])
                                    : "https://suzlon.vtlabs.dev/web/images/2.png"
                                }
                                className="w-[40px] rounded-sm"
                                alt="foodImage"
                              />
                              <p className="text-dynmaicText text-xs mt-1">
                                {i2.quantity} X{" "}
                                <span>
                                  {i2?.foodDetails?.name ?? "--"}
                                  <br />({i2?.foodVariantName})
                                </span>
                              </p>
                            </div>
                            <p className="text-dynmaicText font-inter text-xs">
                              {/* ₹ {i2?.totalItemPriceAfterTax} */}
                              ₹ {i?.totalBasePrice}
                            </p>
                          </div>
                          {idx !== i.orderFoodMappings?.length - 1 && <hr />}
                        </div>
                      ))}

                      {rejected ? (
                        <div className="mt-3 flex items-center gap-2 bg-red-500/10 border border-red-500/40 rounded-md px-3 py-2">
                          <span className="rejected-icon-animate text-red-500 text-lg leading-none">✕</span>
                          <p className="text-red-400 font-inter text-xs font-semibold">Order Rejected</p>
                        </div>
                      ) : (
                        <div className="mt-3">
                          <div className="relative h-2 bg-gray-700 rounded-full overflow-hidden">
                            <div
                              className={`status-progress-fill absolute top-0 left-0 h-full rounded-full bg-gradient-to-r ${colors.bar} ${
                                !isCompleted ? "shimmer-bar" : ""
                              }`}
                              style={{ width: `${progressPercent}%` }}
                            ></div>
                          </div>
                          <div className="flex justify-between mt-1.5">
                            {STATUS_STEPS.map((step, stepIdx) => {
                              const stepColors = STATUS_COLORS[step];
                              const isActive = stepIdx === statusIndex;
                              const isDone = stepIdx < statusIndex;
                              const isReached = stepIdx <= statusIndex;
                              return (
                                <div
                                  key={step}
                                  className="flex flex-col items-center"
                                  style={{ width: `${100 / STATUS_STEPS.length}%` }}
                                >
                                  <div
                                    key={`${step}-${statusKey}`}
                                    className={`w-2.5 h-2.5 rounded-full ${
                                      isReached
                                        ? `${stepColors.dot} status-dot-animate`
                                        : "bg-gray-600"
                                    } ${isActive ? `status-dot-active ${stepColors.text}` : ""}`}
                                  ></div>
                                  <p
                                    className={`text-[9px] mt-1 text-center leading-tight font-inter ${
                                      isDone
                                        ? "text-gray-400"
                                        : isActive
                                        ? `${stepColors.text} font-semibold`
                                        : "text-gray-600"
                                    }`}
                                  >
                                    {STATUS_LABELS[step]}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      <div className="flex justify-between items-center text-xs text-dynmaicText font-inter mt-3">
                        <div className="flex items-center gap-1">
                          {isCompleted && (
                            <span className="check-icon-animate text-green-400 text-sm">✓</span>
                          )}
                          <p
                            key={`label-${statusKey}`}
                            className={`status-text-animate font-semibold ${
                              rejected ? "text-red-500" : colors.text
                            }`}
                          >
                            {rejected ? "Rejected" : STATUS_LABELS[statusKey] || i?.orderStatus}
                          </p>
                        </div>
                      </div>
                      <div className="flex justify-between items-center text-dynmaicText font-inter mt-2">
                        <p className="text-brand">Tax</p>
                        <p className="font-semibold">₹ {i?.totalTax}</p>
                      </div>
                      <div className="flex justify-between items-center text-dynmaicText font-inter mt-2">
                        <p className="text-brand">Total Price</p>
                        <p className="font-semibold">₹ {i?.totalPriceAfterTax}</p>
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-center items-center h-full mt-16 text-dynmaicText">
                      <p className="font-bold text-2xl">No Order Yet!</p>
                    </div>
                  )}
                </div>
              );
            })
          ) : OrderSummary?.total < 1 ? (
            <div className="flex flex-col justify-center items-center bg-dynmaicBg3 p-6 mt-4 rounded-md">
              <img
                src="https://cdn-icons-png.flaticon.com/512/709/709496.png"
                alt="waiting"
                className="w-12 h-12 mb-3 opacity-70"
              />
              <p className="text-yellow-400 font-semibold text-lg">Waiting for Orders...</p>
              <p className="text-gray-400 text-sm mt-1 text-center">
                Your current order is in <span className="text-yellow-400">waiting status</span>.
              </p>
              <div
                onClick={() => navigate(-1)}
                className="font-inter bg-dynmaicBg2 text-center cursor-pointer mt-2 text-dynmaicText p-2"
              >
                <p>Thanks</p>
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center h-full mt-16 text-dynmaicText">
              <p className="font-bold text-2xl">No Order Yet!</p>
            </div>
          )}
        </>
      )}

      {OrderSummary?.total > 0 && (
        <>
          <div className="mt-4 text-dynmaicText font-inter">
            <p>Order Summary</p>
            <div className="w-1/2 h-[2px] bg-green-400 mt-2"></div>
            <div className="mt-2">
              {/* <div className="flex justify-between items-center">
                <p>Tax</p>
                <p>₹ {OrderSummary.tax}</p>
              </div> */}
              <div className="flex justify-between items-center">
                <p>Total Summary</p>
                <p>₹ {OrderSummary.total}</p>
              </div>
            </div>
          </div>
          <div
            onClick={() => navigate(-1)}
            className="font-inter bg-dynmaicBg2 text-center cursor-pointer mt-2 text-dynmaicText p-2"
          >
            <p>Thanks</p>
          </div>
        </>
      )}
    </>
  );
};

export default CurrentOrder;